import React, { useEffect, useState } from "react";
import { Col, Container, Image, ListGroup, Row, Tab } from "react-bootstrap";
import profilepic from "../../../assets/images/dummy-profile-pic.jpg";
import { useDispatch } from "react-redux";
import Loader, { LoaderType } from "../../../component/common-component/Loader";
import { SubscribersContactGetList } from "../../../services/ReduxTookit/Slice/SubscribersContactRedux";
import { CaseUpdateAssign } from "../../../services/ReduxTookit/Slice/CaseRedux";
import Nodata from "../../../component/common-component/Nodata";

function SupportCaseContactModel({
  caseId,
  getCaseDetails,
  handleshowPopup,
  redirect,
  associationtype_term,
}) {
  const dispatch = useDispatch();
  const [contactLoading, setContactLoading] = useState(false);
  const [contactData, setContactData] = useState([]);

  const FilterForWorkflow = (ContactList) => {
    return ContactList?.filter((item) => item.workflowrole);
  };
  const FilterForMachine = (ContactList) => {
    return ContactList?.filter((item) => item.developerrole);
  };
  const fetchContactData = async () => {
    let body = {
      // subscriberid: 0,
      contactname: "",
      email: "",
      contactno: "",
    };
    try {
      setContactLoading(true);

      dispatch(SubscribersContactGetList(body)).then((response) => {
        if (response?.payload?.isValidate) {
          setContactData(response?.payload?.data?.data);
          setContactLoading(false);
        }
        if (!response?.payload?.isValidate) {
          setContactData([]);
          setContactLoading(false);
        }
      });
    } catch (error) {
      setContactLoading(false);
    }
  };
  const CommonRender = ({ item, index }) => {
    return (
      <ListGroup.Item key={index}>
        <Row
          onClick={() => {
            AssignSelectedContact(item);
          }}
          className="align-items-center"
        >
          <Col xs="auto">
            <Image
              roundedCircle
              src={item.profilepic || profilepic}
              alt={item.contactname}
              width={50}
              height={50}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = profilepic;
              }}
            />
          </Col>
          <Col>
            <h6 className="mb-0 fw-bold">{item.contactname}</h6>
            <p className="text-muted mb-0 small">{item.contacttype}</p>
          </Col>
        </Row>
      </ListGroup.Item>
    );
  };
  useEffect(() => {
    fetchContactData();
  }, []);

  const AssignSelectedContact = async (subs_Cont_Data) => {
    let body = {
      caseid: caseId,
      assignto: subs_Cont_Data.userid,
    };
    try {
      dispatch(CaseUpdateAssign(body)).then(async (response) => {
        if (response?.payload?.isValidate) {
          await getCaseDetails(caseId);
          handleshowPopup();
          redirect();
        }
        if (!response?.payload?.isValidate) {
          // await getCaseDetails(caseId);
          // handleshowPopup();
          // setContactData([]);
        }
      });
    } catch (error) {}
  };

  return (
    <>
      <Tab.Container
        id="left-tabs-example"
        defaultActiveKey="first"
        className="underlined-tabing"
        onHide={handleshowPopup}
      >
        <div className="schedular-popup add-project-popup contact-detail-in-flow-page-wrapper workflowdelete-contect cursor-pointer casedetail-collaborator-popup">
          <ListGroup variant="flush">
            <>
              {!contactLoading ? (
                contactData?.length > 0 ? (
                  associationtype_term === "Machine" ? (
                    <>
                      {FilterForMachine(contactData)?.length > 0 ? (
                        FilterForMachine(contactData).map((item, index) => (
                          <CommonRender item={item} index={index} />
                        ))
                      ) : (
                        <Nodata />
                      )}
                    </>
                  ) : (
                    <>
                      {associationtype_term === "Workflow" ? (
                        <>
                          {FilterForWorkflow(contactData)?.length > 0 ? (
                            FilterForWorkflow(contactData).map(
                              (item, index) => (
                                <CommonRender item={item} index={index} />
                              )
                            )
                          ) : (
                            <Nodata />
                          )}
                        </>
                      ) : (
                        <>
                          {contactData.map((item, index) => (
                            <CommonRender item={item} index={index} />
                          ))}
                        </>
                      )}
                    </>
                  )
                ) : (
                  <Nodata />
                )
              ) : (
                <>
                  <Loader type={LoaderType.CasedetailWorkFlowContacts} count={3} />
                </>
              )}
            </>
          </ListGroup>
        </div>
      </Tab.Container>
    </>
  );
}

export default SupportCaseContactModel;
